<template>
  <div v-if="userId && resumeStatus === 'published'" class="cursor-pointer flex items-center justify-center mx-1">
    <vx-tooltip text="Share Talent Card" position="bottom">
      
      <!-- Apply the new circle hover class here -->
      <div @click.stop="shareCard" class="share-btn-circle">
        <feather-icon icon="Share2Icon" svgClasses="w-4 h-4 share-icon" />
      </div>

    </vx-tooltip>
  </div>
</template>

<script>
export default {
  name: "ShareTalentCard",
  props: {
    userId: { type: String, required: true },
    resumeStatus: { type: String, default: "" }
  },
  methods: {
    shareCard() {
      if (!this.userId) return;
      const shareUrl = `${window.location.origin}/p/${this.userId}`;
      navigator.clipboard.writeText(shareUrl).then(() => {
        this.$vs.notify({ title: 'Link Copied!', text: 'Public Talent Card link copied.', color: 'success', iconPack: 'feather', icon: 'icon-check' });
      });
    }
  }
};
</script>

<style scoped>
/* Container for the circle */
.share-btn-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.3s ease;
}

/* Default Icon Color (Vuexy Warning Orange) */
.share-icon {
  color: #FF9F43; 
  transition: all 0.3s ease;
}

/* On Hover: Background becomes Orange */
.share-btn-circle:hover {
  background-color: #FF9F43; 
  box-shadow: 0px 4px 10px rgba(255, 159, 67, 0.3);
}

/* On Hover: Icon becomes White */
.share-btn-circle:hover .share-icon {
  color: #ffffff !important;
  stroke: #ffffff !important;
}
</style>